import { render, staticRenderFns } from "./alacakyaslandirma.vue?vue&type=template&id=33d0a3ea&"
import script from "./alacakyaslandirma.vue?vue&type=script&lang=js&"
export * from "./alacakyaslandirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports